export default __webpack_public_path__ + "static/media/sanmat11.9f8f8605.jpg";